import React from "react";
import { formatDateLong, todayISO } from "../../lib/date";

interface PrintLayoutProps {
  title:     string;
  /// سطر وصفي تحت العنوان — مثلاً المدى التاريخي للتقرير
  subtitle?: string;
  children:  React.ReactNode;
}

export default function PrintLayout({ title, subtitle, children }: PrintLayoutProps) {
  return (
    <>
      {/* ترويسة الطباعة — تظهر فقط عند الطباعة */}
      <div className="print-only mb-6 border-b-2 border-primary-700 pb-4 text-center">
        <img src="/logo.png" alt="" style={{ width: 64, height: 48, objectFit: "contain", margin: "0 auto 6px" }} />
        <p className="text-sm text-gray-600">الجمهورية العربية السورية</p>
        <p className="text-sm text-gray-600">وزارة الدفاع — الإدارة العامة — فرع الشؤون الإدارية</p>
        <h1 className="text-xl font-bold mt-2">{title}</h1>
        {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
        <p className="text-xs text-gray-500 mt-1">تاريخ الطباعة: {formatDateLong(todayISO())}</p>
        <p className="text-[10px] text-gray-400 mt-1">© {new Date().getFullYear()} دائرة المعلوماتية — وزارة الدفاع</p>
      </div>
      {children}
    </>
  );
}
